// src/store/index.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // 定义状态变量
        isShowIframe: false,
        acc:'',
        token:'',
        access_token:'',
        link:'',
        //全局配置参数
        sdk_config:{},
        //上报基础参数
        report_params:{},
        user_params:{
            acc:'',
            access_token:'',
            link:'',
            isShowIframe:false,
            game_id:''
        }
    },
    mutations: {
        //太臃肿了 后期优化
        updateUserParams (state, obj) {
            for (const key in obj) {
                state.user_params[key]=obj[key]
            }
        },
        // updateIframe (state, n) {
        //     state.isShowIframe =n
        // },
        // updateAcc (state, n) {
        //     state.acc =n
        // },
        // updateToken (state, n) {
        //     state.token =n
        // },
        // updateAccessToken(state, n) {
        //     state.access_token =n
        // },
        // updateLinkUrl(state, n) {
        //     state.link =n
        // },
        updateSdkConfig(state, n) {
            state.sdk_config =n
        },
        updateReportParams(state, obj) {
            for (const key in obj) {
                state.report_params[key]=obj[key]
            }
        }
        // 定义同步的状态修改方法
        // increment(state) {
        //     state.count++;
        // },
        // decrement(state) {
        //     state.count--;
        // }
    },
    actions: {
        // 定义异步的状态修改方法
        // increment({ commit }) {
        //     commit('increment');
        // },
        // decrement({ commit }) {
        //     commit('decrement');
        // }
    },
    getters: {
        // 定义获取状态的计算属性
        getAccessToken(state) {
            return state.access_token;
        },
        getReportParams(state) {
            return state.report_params;
        },
        getUserParams: (state) => (key) => {
            return state.user_params[key];
        }
    }
});
